import { JSX } from 'react';
import { EligibilityBlockerContent } from '../../../components/therapy/EligibilityBlockerContent';

export const EligibilityBlocked = (): JSX.Element => {
  return <EligibilityBlockerContent showReturnButton={false} testIdPrefix="eligibility-blocked" />;
};
